"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = __importStar(require("mongoose"));
const enum_1 = require("./enum");
const jobSchema = new mongoose_1.Schema({
    title: { type: String, required: true },
    jobId: { type: String, required: true, unique: true },
    url: { type: String, required: true },
    method: { type: String, required: true },
    schedule: { type: String, required: true },
    headers: { type: Map, of: String },
    maxAttempts: { type: Number, default: 5 },
    attempts: { type: Number, default: 0 },
    isRecurring: { type: Boolean, required: true },
    lastRun: Date,
    nextRun: Date,
    body: {
        type: mongoose_1.default.Schema.Types.Mixed,
        required: false,
    },
    status: {
        type: String,
        enum: Object.values(enum_1.JobStatus),
        default: enum_1.JobStatus.SCHEDULED,
    },
    createdAt: { type: Date, default: Date.now },
    updatedAt: { type: Date, default: Date.now },
});
exports.default = (0, mongoose_1.model)("Job", jobSchema, "scheduled_jobs");
